import { render, staticRenderFns } from "./IncidentRootCauseTrend.vue?vue&type=template&id=55b8152a"
import script from "./IncidentRootCauseTrend.vue?vue&type=script&lang=js"
export * from "./IncidentRootCauseTrend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports